// extracted by mini-css-extract-plugin
export default {"adminConsole":"AdminConsole_adminConsole__SyaiQ","modal":"AdminConsole_modal__cPm+T"};